import React from "react";
import './footer.scss'

export function FooterComponent() {
    const currentYear = new Date().getFullYear();

    return <footer className="footer-wrapper">
        <div className="account-footer text-muted">
            <div className="footer-name-and-copyright">
                {'\u00A9'} {currentYear} Huron Consulting Group Inc. and affiliates. All Rights Reserved.
            </div>
            <div>
                <a className="footer-help-link" href="/help" target="_blank" rel="noopener noreferrer">Help Center</a>
                <a className="footer-policy-link" href="https://www.huronconsultinggroup.com/legal/privacy-statement" target="_blank" rel="noopener noreferrer">Privacy Statement</a>
            </div>
        </div>
    </footer>;
}